import { ProductTemplateIdType } from '../QRMenuBucketReducer/types'

export type WishlistProductType = {
  id: number
  productTemplateId: ProductTemplateIdType
}

export const initialState: WishlistProductType[] = []
